import React, { useState } from 'react';
import {
  AppBar, Toolbar, Typography, Button, Avatar,
  Menu, MenuItem, IconButton, Box, Tooltip,
} from '@mui/material';
import ExploreIcon from '@mui/icons-material/Explore';
import AddIcon from '@mui/icons-material/Add';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import PersonIcon from '@mui/icons-material/Person';
import DarkModeIcon from '@mui/icons-material/DarkMode';
import LightModeIcon from '@mui/icons-material/LightMode';
import { useNavigate } from 'react-router-dom';
import { useAuth, useDarkMode } from '../App';
import { logout } from '../services/auth';

export default function Header() {
  const { user } = useAuth();
  const { darkMode, toggleDarkMode } = useDarkMode();
  const navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);

  const displayName = user?.displayName || user?.userDetails || '';
  const initials = displayName.split(' ').map(w => w[0]).join('').toUpperCase().slice(0, 2) || 'U';

  return (
    <AppBar position="sticky">
      <Toolbar>
        <ExploreIcon sx={{ mr: 1 }} />
        <Typography
          variant="h6"
          sx={{ flexGrow: 1, cursor: 'pointer', fontWeight: 'bold' }}
          onClick={() => navigate('/')}
        >
          TripVibe
        </Typography>
        {user && (
          <Box display="flex" alignItems="center" gap={1}>
            <Tooltip title={darkMode ? 'Switch to light mode' : 'Switch to dark mode'}>
              <IconButton color="inherit" onClick={toggleDarkMode}>
                {darkMode ? <LightModeIcon /> : <DarkModeIcon />}
              </IconButton>
            </Tooltip>
            <Button color="inherit" startIcon={<AddIcon />} onClick={() => navigate('/trips/new')}>
              New Trip
            </Button>
            <IconButton onClick={(e) => setAnchorEl(e.currentTarget)}>
              <Avatar
                src={user?.profilePhotoUrl || undefined}
                sx={{ width: 34, height: 34, bgcolor: user?.avatarColor || 'secondary.main', fontSize: 14 }}
              >
                {initials}
              </Avatar>
            </IconButton>
            <Menu anchorEl={anchorEl} open={Boolean(anchorEl)} onClose={() => setAnchorEl(null)}>
              <MenuItem disabled sx={{ fontSize: 13 }}>{user.userDetails}</MenuItem>
              <MenuItem onClick={() => { setAnchorEl(null); navigate('/profile'); }}>
                <PersonIcon sx={{ mr: 1, fontSize: 18 }} /> Profile
              </MenuItem>
              <MenuItem onClick={() => { setAnchorEl(null); navigate('/admin/users'); }}>
                <AdminPanelSettingsIcon sx={{ mr: 1, fontSize: 18 }} /> Admin
              </MenuItem>
              <MenuItem onClick={logout}>Sign Out</MenuItem>
            </Menu>
          </Box>
        )}
      </Toolbar>
    </AppBar>
  );
}
